import * as yup from "yup";

const DocumentFormValidation = yup.object().shape({
  CategoryId: yup.string().required("Category ID is required"),
  Title: yup
    .string()
    .required("Title is required")
    .matches(/^[A-Za-z]/, "Title must start with an English letter.")
    .matches(
      /^[A-Za-z0-9 .'-]+$/,
      "Title can only include English letters, numbers, spaces, hyphens, apostrophes, and periods."
    )
    .trim("Title must not have leading or trailing spaces.")
    .test(
      "not-only-numbers",
      "Title cannot be only numbers.",
      (value) => !/^\d+$/.test(value)
    ),
  // Category: yup
  //   .array()
  //   .of(
  //     yup.object({
  //       value: yup.string().required("Role value is required"),
  //       label: yup.string().required("Role label is required"),
  //     })
  //   )
  //   .required("Roles are required"),
  file: yup.mixed().required("File is required"),
  Description: yup.string().required("Description is required"),
});

export default DocumentFormValidation;
